import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=2694c1ab&scoped=true"
import script from "./OrderDetail.vue?vue&type=script&lang=js"
export * from "./OrderDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderDetail.vue?vue&type=style&index=0&id=2694c1ab&prod&lang=scss&scoped=true"
import style1 from "./OrderDetail.vue?vue&type=style&index=1&id=2694c1ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2694c1ab",
  null
  
)

export default component.exports